export default __webpack_public_path__ + "57906a94e55ce610df96979187507e24.png";